import { BookingIntegrated } from '../../components/BookingIntegrated/BookingIntegrated';

export default function Forecasts() {
  return <BookingIntegrated mode="FORECAST" />;
}
